import { coerce, lte } from 'semver';

/**
 * Checks if OS version is at least the specified version or higher.
 * The expected Version should be passed as: '9.3.0'
 */
export function isOsVersionAtLeast(osVersion: string, expectedOsVersion: string) {
  try {
    const coercedOsVersion = coerce(osVersion);
    if (!coercedOsVersion) {
      return null;
    }

    return lte(expectedOsVersion, coercedOsVersion, true);
  } catch {
    return null;
  }
}
